import React from "react";
import { Input } from "@/components/ui/input";
import useCurrencyStore from "@/stores/ui/currencyStore";

interface PriceStepProps {
  pricePerNight: string;
  totalPrice: string;
  priceType: "perNight" | "total";
  onPriceChange: (name: string, value: string) => void;
  onPriceTypeChange: (type: "perNight" | "total") => void;
  onKeyDown: (e: React.KeyboardEvent) => void;
}

const PriceStep: React.FC<PriceStepProps> = ({
  pricePerNight,
  totalPrice,
  priceType,
  onPriceChange,
  onPriceTypeChange,
  onKeyDown,
}) => {
  const { selectedCurrency } = useCurrencyStore();

  return (
    <div className="space-y-3">
      <div className="flex items-center flex-shrink-0">
        <div className="flex gap-1.5 bg-indigo-50 p-1 rounded-lg border border-indigo-100 w-[300px]">
          {["perNight", "total"].map((type) => (
            <button
              key={type}
              type="button"
              onClick={() => onPriceTypeChange(type as "perNight" | "total")}
              className={`
                py-1.5 px-3.5 rounded-lg flex items-center gap-2 text-xs font-medium w-[140px]
                ${
                  priceType === type
                    ? "bg-white shadow-md text-indigo-700 border border-indigo-100"
                    : "text-neutral-600 hover:text-indigo-600 hover:bg-white/50"
                }
              `}
            >
              <i
                className={`far fa-${
                  type === "perNight" ? "moon" : "calendar-check"
                } w-3.5 h-3.5`}
              />
              <span className="capitalize">
                {type === "perNight" ? "Per Night" : "Total Cost"}
              </span>
            </button>
          ))}
        </div>
      </div>
      <div className="relative">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral-500 text-[13px]">
          {selectedCurrency.symbol}
        </span>
        <Input
          name={priceType === "perNight" ? "pricePerNight" : "totalPrice"}
          type="number"
          value={priceType === "perNight" ? pricePerNight : totalPrice}
          onChange={(e) => onPriceChange(e.target.name, e.target.value)}
          onKeyDown={onKeyDown}
          placeholder="0.00"
          className="w-full text-sm font-light leading-relaxed focus-visible:outline-none focus-visible:ring-0 rounded-lg pl-7"
        />
      </div>
    </div>
  );
};

export default PriceStep;
